import { ENTITIES } from '@/api/api.constant';
import { PromotedEvent } from '@/types/promoted-events';
import { apiBaseUrl, categoryIds } from '@/utils/constants';

const fieldsEvent = (
    [
        'id',
        'event.id',
        'event.name',
        'event.translations.event_name',
        'event.image_cover.id',
        'event.animated',
        'event.duration',
        'event.start_date',
        'event.image_cover.filename_disk',
    ] satisfies Array<
        | keyof PromotedEvent
        | `event.${keyof PromotedEvent['event']}`
        | `event.translations.${keyof PromotedEvent['event']['translations'][number]}`
        | `event.image_cover.${keyof PromotedEvent['event']['image_cover']}`
    >
).join(',');

const fieldsServices = (
    [
        'id',
        'service.animated',
        'service.gallery.image_file.id',
        'service.gallery.image_file.filename_disk',
        'service.name',
        'service.id',
        'service.slug',
        'service.translations.name',
    ] satisfies Array<
        | keyof PromotedEvent
        | `service.${keyof PromotedEvent['service']}`
        | `service.gallery.image_file.${keyof PromotedEvent['service']['gallery'][number]['image_file']}`
        | `service.translations.${keyof PromotedEvent['service']['translations'][number]}`
    >
).join(',');

export const getPromoEvents = async (
    event_type: string,
    countryCode: string,
    language: string,
    limit: number,
    offset: number,
) => {
    const filter = encodeURIComponent(
        JSON.stringify({
            _and: [
                { date_from: { _lte: '$NOW' } },
                { date_to: { _gte: '$NOW' } },
                { enabled: { _eq: true } },
                { event_type: { _eq: event_type } },
                {
                    _or: [
                        {
                            event: {
                                company: { company: { countries: { country: { code: { _eq: countryCode } } } } },
                            },
                        },
                        { event: { company: { company: { countries: { country: { code: { _null: true } } } } } } },
                    ],
                },
                { _or: [{ event: { hidden: { _eq: false } } }, { event: { hidden: { _null: true } } }] },
            ],
            _or: [
                { event: { status: { _eq: 'scheduled' } } },
                { service: { status: { _eq: 'active' } } },
                { _and: [{ event: { hidden: { _eq: false } } }, { event: { hidden: { _null: true } } }] },
            ],
        }),
    );

    const fields = event_type === categoryIds.event ? fieldsEvent : fieldsServices;

    const deep = encodeURIComponent(
        JSON.stringify({
            event: { translations: { _filter: { language: { _eq: language } } } },
        }),
    );

    const url = `${apiBaseUrl}${ENTITIES.promotedEvents}?fields=${fields}&filter=${filter}&deep=${deep}&sort[]=order&limit=${limit}&offset=${offset}`;
    const response = await fetch(url).then((res) => res.json());
    return response?.data || [];
};
